<div class="errorpage">
    <p class="messages">
        Uh oh... Something's wrong.<br>
        Can't load this site.
    </p>
    <a class="btn btn btn--primary is-light" href="/">Bring me home</a>
</div>

<style>
    .errorpage {
        padding: 4rem 0;
        text-align: center;
        margin: auto;
    }
</style>